<template>
  <q-layout v-bind="$attrs">
    <slot></slot>
  </q-layout>
</template>
